import React,{useEffect, useState} from 'react'



import { TextInput } from '../../components/input'
import { LogInService } from '../../services/AuthServices';
import { useDispatch } from 'react-redux';
import { LogInAction, LogOutAction } from '../../redux/actions/authAction';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import {AiFillEye,AiFillEyeInvisible} from 'react-icons/ai';
import { GetTeacherListService, TeacherLogInService } from '../../services/class_booking/TeacherServices';

function Login() {

    const [data,setdata] = useState({user_id:'',password:''});
    const [error,seterror] = useState({user_id:'',password:''});

    const [visible,setvisible] = useState(false)

    const [step,setstep] = useState('Employee')

    const stages = ['Employee','Teacher','Franchise']

    
    const dispatch = useDispatch();
    const navigate = useNavigate();



    useEffect(()=>{  
        dispatch(LogOutAction())
    },[])


    function handlechange(e){
        setdata({...data,[e.target.name] : e.target.value})
        seterror({...error,[e.target.name]:''})
    }

    function onKeyDownHandler(e){
       
        if (e.keyCode === 13) {
            submitform();
        }
    }

    async function submitform(){

        if(!data.user_id){
            toast.error('Mobile No is required')
            seterror({...error,user_id:'Mobile No is required'})
        }else if(!data.password){
            toast.error('Password field is required')
            seterror({...error,password:'Password field is required'})
        }else{
            if(step === 'Employee'){
            const response = await LogInService(data)
            if(response.status === 200){
                dispatch(LogInAction({...response.data,logged_user_type:'Employee'}))
                if(response?.data?.app_access){
                    // let roles = response.data.roles
                    // if(['admin','visitor_user','visitor_creator','visitor_admin'].filter((f)=>roles?.includes(f)).length > 0){
                    //     navigate('/visitor')
                    // }else if(['admin','visitor_user','visitor_creator','visitor_admin'].filter((f)=>roles?.includes(f)).length > 0){
                    //     navigate('/vehicle')
                    // }else if(roles.includes('controller')){
                    //     navigate('/settings')
                    // }else{
                    //   toast.error("You don't have declared role to access this application")
                    // }
                     navigate('/dashboard/my_dashboard')
                }else{
                    toast.error("You don't have any access to this application")
                }
            }else if(response.status === 401){
                toast.error(response.data.errors)
                seterror({...error,password:"Invalid User Id or Password"})
            }
            }else if(step === 'Teacher'){
                const response = await TeacherLogInService(data)
                console.log("response",response?.data)
                if(response.status === 200){
                    dispatch(LogInAction({...response.data,logged_user_type:'Teacher'}))
                    if(response?.data?.app_access){
                        navigate('/dashboard/my_dashboard')
                    }else{
                        toast.error("You don't have any access to this application")
                    }
                }else if(response.status === 401){
                    toast.error(response.data.errors)
                    seterror({...error,password:"Invalid User Id or Password"})
                }
            }
        }
    }

    function setstepfunc(s){
        if(s === 'Employee'){
            navigate('/')
        }
        if(s === 'Teacher'){
            navigate('/teacher_login')
        }
        if(s === 'Franchise'){
            navigate('/distributor_login')
        }
        setstep(s)
    }

  return (

   <div className='relative'>
      {/* <div  className='bg-black/50 z-0 absolute top-0 left-0 w-screen md:h-screen'></div>   */}

   <div className="bg-app-banner flex items-center justify-center  bg-center w-[100vw] bg-cover h-[100vh]">
    <div className='flex  z-20 justify-center  items-center' >

         <div className=''>
            <div className='p-3 z-40 px-5 w-72 bg-white'  >  

            <h6 className='text-[18px] font-[800]'>Sign In</h6>      
            <h6 className={`text-[10px] font-[400] leading-normal mb-4 my-2`}>Add your official phone and password to access all the features provided to you.</h6>

             <div className='flex mb-2 items-center border-y overflow-x-auto flex-nowrap'>
                {stages?.map((s)=>(
                <h6 onClick={()=>{setstepfunc(s)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
             </div>
            
            <form
             onKeyDown={onKeyDownHandler}
             onSubmit={submitform}
            > 
            <TextInput 
                label={'Employee Id'}  
                variant="standard"
                name="user_id"
                type="text"
                value={data.user_id}
                handlechange={handlechange}
                placeholder="Enter your mobile no"
                InputLabelProps={{
                    style: { color: '#fff', }, 
                }}/>


            <div className='relative'>
            <TextInput 
                label={'Password'}  
                variant="standard"
                name="password"
                type={visible ? "text" : "password"}
                value={data.password}
                handlechange={handlechange}
                placeholder="Enter your password"
                InputLabelProps={{
                    style: { color: '#fff', }, 
                }}/>  
               {visible ?  <AiFillEye className='absolute right-1 top-[24px] cursor-pointer text-slate-200 ' onClick={()=>setvisible(!visible)} /> : <AiFillEyeInvisible className='absolute right-1 top-[24px] cursor-pointer text-slate-200 ' onClick={()=>setvisible(!visible)} />}
            </div>



                <h6 onClick={submitform} className="bg-[#de9f19] text-black cursor-pointer text-center mt-4  font-[500] py-[8px] px-4 mt-0  w-full rounded-md border-[#de9f19]  text-[14px] hover:border-[#de9f19]">SIGN IN</h6>
            </form>

            <h6 className='text-[10px] mt-4 text-800 leading-normal'>By continuing, you agree to My Vidyalaya<span className='text-black font-bold text-[#0a69da]'> Conditions of Use</span>  and <span className='text-black font-bold text-[#0a69da]'> Privacy Notice </span> .</h6>



            </div>
        </div>  
    </div> 
    </div>
    </div>

      
  )
}

export default Login